/**
 * Identity function to provide TypeScript autocomplete for Tempo configurations.
 */
export function defineConfig(config) {
    return config;
}
